// SideBarLink Elements
import { ChevronDown } from 'react-feather';
import { LinkProps } from 'react-router-dom';
import styled from 'styled-components';
import { ThemeInterface } from '../../theme/ThemeInterface';
import { Span } from '../../typography';

import Collapse from '../Collapse';
import { CleanNavLink } from '../CleanNavLink';
import { IS_VENDOR } from '../../consts';
import { theme } from '../../theme';
// import { IS_VENDOR } from '../../consts';

type NavItemWrapperProps = {
  bg?: string;
  open: boolean;
  hasSubMenu?: boolean;
};

type LetterAvatarProps = {
  open: boolean;
};

type StyledCollapseProps = {
  open: boolean;
  className?: string;
  sidebarOpen: boolean;
  active?: boolean;
};

type StyledLinkProps = LinkProps & {
  to: string;
  open: boolean;
  className: string;
  hasSubMenu: boolean;
  childLinkActive: any;
  activeClassName: string;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
};

const PseudoStyles = `
  & > div {
  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 5px;
    background-color: #009bda;
    border-top-right-radius: 5px;
  }
  & > svg {
    color: #009bda !important;
    fill: #009bda !important;
  }`;

const RadiusStyles = `
  &:before {
    border-bottom-right-radius: 5px;
    transition: all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }`;

export const Tooltip = styled.div`
  opacity: 0;
  left: 70px;
  display: flex;
  font-size: 13px;
  border-radius: 5px;
  visibility: hidden;
  position: absolute;
  align-items: center;
  justify-content: center;
  transform: translateX(10px);
  flex-direction: column;
  background-color: rgba(40, 42, 47, 1);
  & p {
    margin: 0 !important;
    color: white;
    text-transform: uppercase;
  }
  &:after {
    top: 50%;
    width: 0;
    margin: 0;
    height: 0;
    left: -5px;
    content: '';
    line-height: 0;
    position: absolute;
    transform: translateY(-50%);
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-right: 5px solid ${(props: ThemeInterface) => props.theme.colors.coal};
  }
`;

export const NavItemWrapper = styled.div<NavItemWrapperProps>`
  flex: 1;
  height: 55px;
  display: flex;
  position: relative;
  align-self: stretch;
  align-items: center;
  white-space: nowrap;
  background: transparent;
  justify-content: flex-start;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    background: ${props =>
      props.open ? (IS_VENDOR ? 'rgba(180, 180, 180, 0.35)' : theme.colors.transparentBlack) : 'transparent'};
  }
  &:hover ${Tooltip} {
    opacity: 1;
    width: auto;
    padding: 10px;
    visibility: visible;
    transform: translateX(0);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const StyledLink = styled(CleanNavLink)<StyledLinkProps>`
  display: flex;
  align-self: stretch;
  text-decoration: none;
  ${props => !props.open && RadiusStyles};
  ${props => props.childLinkActive && PseudoStyles};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &.active-nav-link > div svg {
    z-index: ${theme.zIndex[5]};
    stroke: ${(props: ThemeInterface) => (IS_VENDOR ? props.theme.colors.coal : props.theme.colors.putty)};
  }
  &.active-nav-link > div ${Span} {
    color: ${(props: ThemeInterface) => (IS_VENDOR ? props.theme.colors.coal : props.theme.colors.putty)};
  }
  &.active-nav-link ${NavItemWrapper} {
    background-color: ${(props: ThemeInterface) =>
      IS_VENDOR ? 'rgba(180, 180, 180, 0.35)' : props.theme.colors.transparentBlack};
  }
  &:hover > div svg {
    z-index: ${theme.zIndex[5]};
    stroke: ${(props: ThemeInterface) => (IS_VENDOR ? props.theme.colors.coal : props.theme.colors.putty)};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  &:hover ${Span} {
    color: ${(props: ThemeInterface) => (IS_VENDOR ? props.theme.colors.white : props.theme.colors.putty)};
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  &:hover ${NavItemWrapper} {
    background-color: ${(props: ThemeInterface) => props.theme.colors.transparentBlack};
  }
`;

export const StyledSubMenuLink = styled(CleanNavLink)`
  width: 100%;
  text-decoration: none;
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  &:hover {
    background-color: ${(props: ThemeInterface) => props.theme.colors.transparentBlack};
  }
  &:hover ${Span} {
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    color: ${(props: ThemeInterface) => props.theme.colors.white};
  }
`;

export const StyledCollapse = styled(Collapse)<StyledCollapseProps>`
  width: 100%;
  position: relative;
  overflow: ${props => props.open && !props.sidebarOpen && 'visible !important'};
  span {
    font-size: 14px !important;
  }
  .nav-item__container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 10px;
    text-indent: 15%;
    a {
      width: 100%;
      ${props =>
        !props.open &&
        `
        display: flex;
        justify-content: center;
        `};
    }
  }
  & > svg {
    color: ${props => (props.active ? props.theme.colors.putty : 'white')} !important;
  }
`;

export const StyledExpand = styled(ChevronDown)<any>`
  right: 15px;
  position: absolute;
  opacity: ${props => (props.open ? 1 : 0)};
  visibility: ${props => (props.open ? 'visible' : 'hidden')};
  color: ${(props: ThemeInterface) => props.theme.colors.white};
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94) !important;
  transform: ${props => (props.expanded ? 'rotateX(180deg)' : 'rotateX(0deg)')};
`;

export const LetterAvatar = styled.div<LetterAvatarProps>`
  height: 100%;
  display: flex;
  position: relative;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  opacity: ${props => (props.open ? 0 : 1)};
  width: ${props => (props.open ? 0 : '100%')};
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  color: ${(props: ThemeInterface) => props.theme.colors.putty};
  &:hover ${Tooltip} {
    opacity: 1;
    width: auto;
    visibility: visible;
    transform: translateX(0);
    transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
`;

export const P = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  color: ${(props: ThemeInterface) => props.theme.colors.white};
`;



// WEBPACK FOOTER //
// ./src/components/sidebar/SideBarLinkElements.tsx